module.exports = __webpack_public_path__ + "static/mappy-f7794ba37111a846128f931617bfcd9b.png";